export const LANGUAGE_OPTIONS = [
  { name: 'Български', isoCountryCode: 'bg' },
  { name: 'Čeština', isoCountryCode: 'cs' },
  { name: 'Dansk', isoCountryCode: 'da' },
  { name: 'Deutsch', isoCountryCode: 'de' },
  { name: 'English (UK)', isoCountryCode: 'en' },
  { name: 'English (US)', isoCountryCode: 'us' },
  { name: 'Español', isoCountryCode: 'es' },
  { name: 'Français', isoCountryCode: 'fr' },
  { name: 'Italiano', isoCountryCode: 'it' },
  { name: 'Magyar', isoCountryCode: 'hu' },
  { name: 'Nederlands', isoCountryCode: 'nl' },
  { name: 'Norsk', isoCountryCode: 'nb' },
  { name: 'Polski', isoCountryCode: 'pl' },
  { name: 'Português', isoCountryCode: 'pt' },
  { name: 'Română', isoCountryCode: 'ro' },
  { name: 'Русский', isoCountryCode: 'ru' },
  { name: 'Slovenčina', isoCountryCode: 'sk' },
  { name: 'Slovenščina', isoCountryCode: 'sl' },
  { name: 'Suomi', isoCountryCode: 'fi' },
  { name: 'Svenska', isoCountryCode: 'sv' },
  { name: 'Türkçe', isoCountryCode: 'tr' },
  { name: 'Українська', isoCountryCode: 'uk' },
  { name: 'Ελληνικά', isoCountryCode: 'el' },
  { name: 'ไทย', isoCountryCode: 'th' },
  { name: '中文（简体）', isoCountryCode: 'zh-CN' },
  { name: '中文（繁體）', isoCountryCode: 'zh-TW' },
  { name: '日本語', isoCountryCode: 'ja' },
  { name: '한국어', isoCountryCode: 'ko' },
];

export const DEFAULT_ANGULAR_LOCALE = 'en-US';

export const langToAngularLocale: Record<string, string> = {
  bg: 'bg',
  cs: 'cs',
  da: 'da',
  de: 'de',
  en: 'en-GB',
  us: 'en-US',
  es: 'es',
  fr: 'fr',
  it: 'it',
  hu: 'hu',
  nl: 'nl',
  nb: 'nb',
  pl: 'pl',
  pt: 'pt-PT',
  ro: 'ro',
  ru: 'ru',
  sk: 'sk',
  sl: 'sl',
  fi: 'fi',
  sv: 'sv',
  tr: 'tr',
  uk: 'uk',
  el: 'el',
  th: 'th',
  'zh-CN': 'zh-Hans',
  'zh-TW': 'zh-Hant',
  ja: 'ja',
  ko: 'ko',
};

export function resolveLocale(isoCountryCode?: string | null): string {
  if (!isoCountryCode) {
    return DEFAULT_ANGULAR_LOCALE;
  }

  return langToAngularLocale[isoCountryCode] ?? DEFAULT_ANGULAR_LOCALE;
}


